import { Popover as BasePopover } from "@base-ui/react/popover";

import type { TimePickerBackdropProps } from "./TimePicker.types";

export function TimePickerBackdrop({ ...props }: TimePickerBackdropProps) {
  return <BasePopover.Backdrop data-slot="time-picker-backdrop" {...props} />;
}
